import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a36228c0&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style1 from "./detail.vue?vue&type=style&index=1&id=a36228c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36228c0",
  null
  
)

export default component.exports